import { getData } from 'conversations-async-data/async-data/operators/getters';
import { createSelector } from 'reselect';
import { getOmnibusErrorsAsyncData } from './getOmnibusErrorsAsyncData';
export const getOmnibusRequestError = createSelector([getOmnibusErrorsAsyncData], asyncData => {
  const data = getData(asyncData);
  if (!data) return [];
  return data.requestErrorTypes;
});